import {useLocation, useNavigate} from "react-router-dom";
import {TitlePage} from "../../../shared";
import React, {useEffect, useMemo, useRef} from "react";
import {useSelector} from "react-redux";
import users from "../../../users";
import {useIntl} from "react-intl";
import {ScrollModal} from "../../../shared/scroll-modal";
import {OptionButton} from "../../../shared/option-button";
import {ScrollModalApi} from "../../../shared/scroll-modal/view";
import {SquadflixDevice, SquadflixTvHook} from "../../../../hooks/useSquadflixTv";
import {getDeviceIcon} from "../../../../utils/devices-constants";
import './cap17driveHeader.css';

type Props = {
    squadflixTvHook: SquadflixTvHook;
}

const Cap17driveHeader = ({squadflixTvHook}: Props) => {

    const intl = useIntl();
    const location = useLocation();
    const navigate = useNavigate();
    const [typeSelected, setTypeSelected] = React.useState(null);
    const [openedSelector, setOpenedSelector] = React.useState(false);
    const darkMode = useSelector(users.selectors.isDarkMode);
    const scrollModalApi = useRef<ScrollModalApi>();

    useEffect(() => {
        let type = location.pathname.split("/")[2];
        if (type === "home" || type === "") {
            type = undefined;
        }
        setTypeSelected(type);
    }, [location]);


    const options = useMemo(() => {
        return [
            {
                icon: "fa-solid fa-house",
                text: intl.formatMessage({id: "squadflix-header.home"}),
                hideBigScreen: false,
            },
            {
                icon: "fa-solid fa-tower-broadcast",
                text: intl.formatMessage({id: "squadflix.live"}),
                type: "live",
            },
            {
                icon: "fa-solid fa-magnifying-glass",
                text: "Buscar",
                type: "search-tmdb",
            }
        ]
    }, [intl]);

    const handleSelect = (type) => {
        if (type === typeSelected) {
            return;
        }

        setOpenedSelector(false);

        if (!type) {
            navigate(`/squadflix`);
            return;
        }
        navigate(`/squadflix/${type}`);
    }

    const selectedOption = useMemo(() => {
        return options.find(x => x.type == typeSelected);
    }, [typeSelected, options]);

    const handleOpenLinkerMenu = () => {
        if (scrollModalApi.current) {
            scrollModalApi.current.open();
        }
    }

    const onClickSendOption = (receptor?: SquadflixDevice) => {
        squadflixTvHook.connectTo(receptor);
        if (scrollModalApi.current) {
            scrollModalApi.current.close();
        }
    }

    return (
        <>
            <TitlePage
                className="mb-4"
                disableScroll
                leftClass="col-12"
                title={<div
                    className="d-flex flex-row justify-content-center align-items-center w-100 cap17drive-header__title fs-4">
                    <div className="d-flex flex-row align-items-center gap-4">
                        <div onClick={() => handleSelect(null)} style={{
                            cursor: "pointer"
                        }}>
                            <i className="fa-solid fa-solid fa-clapperboard"></i>&nbsp; SquadFlix
                        </div>
                        {!!squadflixTvHook?.availableReceptors?.length &&
                            <div className="squadflix-header__casting-icon" onClick={handleOpenLinkerMenu}>
                                <i className="fa-brands fa-chromecast fa-lg"></i>
                                <span
                                    className="squadflix-header__casting-icon__badge translate-middle badge rounded-pill bg-danger">
                                    {squadflixTvHook.availableReceptors.length}
                                </span>
                            </div>}
                    </div>
                </div>} icon={undefined} rightOptions={undefined} titleClass={undefined} rightClass={undefined}
                hideSeparator={true} fixedHeight={undefined} style={undefined}/>

            {!!squadflixTvHook?.availableReceptors?.length &&
                <ScrollModal header={
                    <TitlePage style={{
                        height: "59px",
                    }} icon={"fa-brands fa-chromecast fa-lg"} hideSeparator
                               title="Enviar a SquadFlix TV" className="p-3 ps-1"
                               rightOptions={
                                   <button className="btn btn-outline-danger"
                                           onClick={() => onClickSendOption(undefined)}>
                                       <i className="fa-solid fa-circle-stop fa-xl"></i>
                                   </button>}
                               titleClass={undefined} leftClass={undefined} rightClass={undefined}
                               disableScroll={undefined} fixedHeight={undefined}/>
                } ref={scrollModalApi}>
                    {squadflixTvHook.availableReceptors.map(x => (
                        <OptionButton onClick={() => onClickSendOption(x)}
                                      key={x.deviceId}
                                      text={x.name}
                                      disabled={squadflixTvHook.connectedReceptor?.deviceId == x.deviceId}
                                      icon={<i className={getDeviceIcon(x.type)}></i>}/>
                    ))}
                </ScrollModal>}
        </>
    )
}

export default Cap17driveHeader;
